/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Home_Faq_5_1Inputs */

const en_settings_home_faq_5_1 = /** @type {(inputs: Settings_Home_Faq_5_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` for help updating
            your primary email address.`)
};

/**
* | output |
* | --- |
* | "for help updating your primary email address." |
*
* @param {Settings_Home_Faq_5_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_home_faq_5_1 = /** @type {((inputs?: Settings_Home_Faq_5_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Home_Faq_5_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_home_faq_5_1(inputs)
});